import {useAppSelector} from '../../../../../hooks/react-redux'
import {getBuild} from '../../../../../selectors'
import {useSequenceLoaderReadyHandler} from '../../../../common/SequenceLoader/SequenceLoader.hooks'

import Deployments from './Deployments'
import type {OwnProps} from './Deployments.types'

export default function DeploymentsContainer({buildId}: OwnProps) {
  const buildTypeId = useAppSelector(state => getBuild(state, buildId)?.buildType)
  const disabled = useAppSelector(state => {
    const {state: buildState, personal} = getBuild(state, buildId) ?? {}
    return personal === true || buildState !== 'finished'
  })
  useSequenceLoaderReadyHandler(disabled || buildTypeId == null)

  return disabled || buildTypeId == null ? null : (
    <Deployments buildId={buildId} buildTypeId={buildTypeId} />
  )
}
